import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMutationIdentifyAuthentication } from "../../query/users/mutations";
import { KEY_REDIRECT_PATH } from "../screens/AuthSSO";
import {
  redirectToV3SignIn,
  shouldRedirectToV3
} from "../utils/v3LoginRedirect";

export function useLoginHintRedirect() {
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const processed = useRef(false);
  const [identifyAuth] = useMutationIdentifyAuthentication();

  useEffect(() => {
    if (processed.current) {
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const loginHint = searchParams.get("login_hint");

    if (!loginHint) {
      return;
    }

    processed.current = true;
    setIsRedirecting(true);

    const performRedirect = async () => {
      try {
        const response = await identifyAuth(
          { email: loginHint },
          { throwOnError: true }
        );

        if (
          response &&
          shouldRedirectToV3({
            migrateToV3: response.migrateToV3,
            authenticationStrategy: response.authenticationStrategy
          }) &&
          redirectToV3SignIn(loginHint)
        ) {
          return;
        }

        if (response?.authenticationStrategy === "SingleSignOn") {
          const redirectPath = location.hash?.slice(1);
          if (redirectPath) {
            sessionStorage.setItem(KEY_REDIRECT_PATH, redirectPath);
          }
          window.open(response?.authenticationUrl, "_self");
        } else {
          setIsRedirecting(false);
        }
      } catch {
        setIsRedirecting(false);
      }
    };

    performRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isRedirecting };
}
